import {useGtagEventLocation} from 'hooks/analytics/gtag/helpers/useGtagEventLocation';
import {useGetUserQuery} from 'modules/user/services';
import {useUserCity} from 'modules/locations/hooks/useUserCity';
import {useMemo} from 'react';
import {EventAction, EventCategory, EventNames, EventUserAuth} from 'modules/google-analytics/constants';
import {isBrowserContext} from 'core/helpers';

export const useGtagUserData = ({
    pageType,
    portalName = 'Shop',
    categoryName,
    itemName,
}: {
    pageType?: string;
    portalName?: string;
    categoryName?: string;
    itemName?: string;
}) => {
    const {data: user} = useGetUserQuery();

    const {eventLocation} = useGtagEventLocation();

    const cityInfo = useUserCity();
    const cityId = cityInfo?.id;
    const cityName = cityInfo?.title;

    const userId = user?.goldId ?? user?.id;
    const userPhone = user?.phone;
    const userEmail = user?.email;
    const isLoggedIn = user?.isAuthorized;
    const regDate = user?.regDate;
    const userType = user?.userType;
    // const isSubscribed = user?.isSubscribed ? '1' : '0';
    const isSubscribed = null;

    const customReferrer = isBrowserContext() && window.location.href !== document.referrer ? document.referrer : '';

    const loggedInGTMData = useMemo(
        () => ({
            categoryName,
            cityId,
            cityName,
            event: EventNames.OWOX,
            eventAction: EventAction.PageView,
            eventCategory: EventCategory.Interactions,
            itemName,
            pageType: pageType ?? eventLocation,
            portalName,
            regDate,
            userAuth: EventUserAuth.Auth,
            userEmail,
            userId,
            userPhone,
            userType,
            isSubscribed,
        }),
        [
            categoryName,
            cityId,
            cityName,
            eventLocation,
            isSubscribed,
            itemName,
            pageType,
            portalName,
            regDate,
            userEmail,
            userId,
            userPhone,
            userType,
        ],
    );

    const defaultGTMData = useMemo(
        () => ({
            categoryName,
            cityId,
            cityName,
            event: EventNames.OWOX,
            eventAction: EventAction.PageView,
            eventCategory: EventCategory.Interactions,
            itemName,
            pageType: pageType ?? eventLocation,
            portalName,
            userAuth: EventUserAuth.NotAuth,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            ...(customReferrer ? {custom_referrer: customReferrer} : {}),
        }),
        [categoryName, cityId, cityName, customReferrer, eventLocation, itemName, pageType, portalName],
    );

    if (!categoryName) {
        delete loggedInGTMData.categoryName;
        delete defaultGTMData.categoryName;
    }
    if (!itemName) {
        delete loggedInGTMData.itemName;
        delete defaultGTMData.itemName;
    }

    return isLoggedIn ? loggedInGTMData : defaultGTMData;
};
